<div class="header-label">Communications</div>
<div class="content-block dx-card responsive-paddings p-3 mb-3">
    <dx-form [formData]="filter" [colCount]="4" (onEditorEnterKey)="search()">
        <dxi-form-item dataField="customer" [label]="{ text: 'Customer' }"></dxi-form-item>
        <dxi-form-item dataField="invoiceNumber" [label]="{ text: 'Invoice #' }"></dxi-form-item>
        <dxi-form-item
            dataField="type"
            [label]="{ text: 'Type' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: typeOptions, showClearButton: true }"
        ></dxi-form-item>
        <dxi-form-item itemType="empty"></dxi-form-item>
        <dxi-form-item dataField="createdFrom" [label]="{ text: 'Created From' }" editorType="dxDateBox"></dxi-form-item>
        <dxi-form-item dataField="createdTo" [label]="{ text: 'Created To' }" editorType="dxDateBox"></dxi-form-item>
        <dxi-form-item itemType="empty" [colSpan]="2"></dxi-form-item>
        <dxi-form-item [colSpan]="4">
            <div *dxTemplate class="btn-toolbar justify-content-end align-items-center">
                <button type="button" accesskey="s" (click)="search()" class="btn btn-primary me-1">Search</button>
                <button type="button" (click)="clear()" class="btn btn-light">Clear</button>
            </div>
        </dxi-form-item>
    </dx-form>
</div>
<div class="flex-fill d-flex flex-column content-block dx-card p-3">
    <div class="flex-fill d-flex flex-column">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            class="flex-fill d-flex flex-column"
            height="100px"
            [dataSource]="communications"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
        >
            <dxi-data-grid-column dataField="type" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="sent" dataType="date" format="shortDateShortTime" width="200"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="invoiceId" width="100" cellTemplate="invoiceLinkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="invoiceNumber"
                caption="Invoice #"
                width="100"
                cellTemplate="invoiceLinkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="rentalDisplay"
                caption="Rental"
                width="100"
                cellTemplate="rentalLinkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="status" width="125"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="customer" width="300" cellTemplate="customerLinkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="created" dataType="date" format="shortDateShortTime" width="250"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="createdBy" width="150"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="error" width="350"></dxi-data-grid-column>
            <dxi-data-grid-column></dxi-data-grid-column>

            <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                @if (cell) {
                    <a [routerLink]="'/invoices/' + cell.data.invoiceId" [innerHtml]="cell.text"></a>
                }
            </div>
            <div *dxTemplate="let cell of 'rentalLinkTemplate'">
                @if (cell) {
                    <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
                }
            </div>
            <div *dxTemplate="let cell of 'customerLinkTemplate'">
                @if (cell) {
                    <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
                }
            </div>

            <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
            <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
            <dxo-data-grid-state-storing
                [enabled]="true"
                type="localStorage"
                storageKey="invoice-communications-grid"
            ></dxo-data-grid-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                @if (communications) {
                    <span class="me-3">
                        <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
                    </span>
                }
            </div>
        </dx-data-grid>
    </div>
</div>
